<template>
  <timeline :entries="entries"/>
</template>

<script>
  import Timeline from "@/components/Timeline.vue";

  export default {
    name: 'ExperiencesComponent',
    components: {Timeline},
    data: function () {
      return {
        entries: [
          {
            title: 'Citron Digital',
            role: 'Micro-entrepreneur',
            period: 'Depuis juillet 2020',
            text: 'Micro-entrepreneur spécialisé dans la création d\'applications web (SaaS) et de sites web :',
            items: [
              'Accompagnement et conseil client',
              'Conception, création, hébergement d\'applications et de sites web (VueJs, Meteor, NodeJs, MongoDB, OVH)',
              'Création du Gestionnaire Citron : devis, factures Factur-X, encaissements, achats et stock, export comptable FEC et statistiques',
              'DevOps : GitLab (container registry, repository npm et runner), intégration continue',
              'Facturation, gestion, commercial, administratif',
              'Marketing digital',
              'Micro-services REST avec NodeJs (express), Docker, MongoDB, RabbitMQ (service MQTT)',
              'Vue3, CSS réalisé en mobile first'
            ],
            logo: '/img/citrondigital_logo.png',
            logoOnDark: true
          },
          {
            title: 'Viveris, Toulouse',
            role: 'Ingénieur logiciel',
            period: 'Depuis mars 2021',
            text: 'Ingénieur logiciel full stack dans le domaine de la télécommunication :',
            items: [
              'Java, Vue, PHP, Python',
              'CI : Jenkins, OpenStack',
              'Oracle Linux, Apache',
              'Développement de nouvelles fonctionnalités et correction de bugs',
              'Environnement agile',
              'Validation et qualité (SquashTest)',
              'Tests automatisés en TypeScript via l\'API Puppeteer et intégration dans Jenkins',
              'Image Docker avec PJSUA2 pour réaliser et recevoir des appels SIP',
              'Application Vue3 (REST via Report Portal) qui affiche les résultats des tests automatiques'
            ],
            logo: '/img/viveris.png'
          },
          {
            title: 'Capcir, Toulouse',
            role: 'Ingénieur logiciel',
            period: 'Octobre 2020 à mars 2021',
            text: 'Ingénieur logiciel dans le domaine de la santé, spécialisé dans la réalisation et la maintenance d\'une infrastructure de test :',
            items: [
              'Remise en place des tests unitaires et d\'intégration',
              'Intégration continue avec GitLab Runner et Docker',
              'Correction de tickets en hotline',
              'Développement de nouvelles fonctionnalités'
            ],
            logo: '/img/capcir.png'
          },
          {
            title: 'Acelys Service Numérique, Montpellier',
            role: 'Développeur full stack',
            period: 'Depuis janvier 2019',
            text: 'Développement et maintenance d\'un logiciel JEE au sein d\'un centre de service :',
            items: [
              'Java EE (version 8), Spring, Hibernate',
              'SQL, PL/SQL (Oracle)',
              'Angular et Vaadin',
              'Équipe de 15 personnes (Scrum)',
              'Migration d\'AngularJS vers Angular 6',
              'Web services REST',
              'Tests unitaires et d\'intégration (JUnit)',
              'Tests de non-régression avec Selenium/Zalenium et Protractor',
              'Maintenance et développement (tickets Redmine et Jira)',
              'Correspondant sécurité des systèmes d\'information (CSSI)',
              'Intégration continue avec Jenkins',
              'Mapper Selma'
            ],
            logo: '/img/acelys.png',
            logoOnDark: true
          },
          {
            title: 'Renault, Metz',
            role: 'Développeur full stack (alternance)',
            period: 'Septembre 2017 à décembre 2018',
            text: 'Développement d\'un ERP au sein de l\'un des ateliers de l\'usine. L\'analyse des processus métier est très sollicitée. Langages utilisés : HTML, CSS, PHP, JS, MySQL.',
            logo: '/img/groupe-renault.png'
          },
          {
            title: 'Laboratoire Arago, Banyuls-sur-Mer',
            role: 'Développeur d\'objets connectés',
            period: '2017',
            text: 'Développement de plusieurs projets d\'objets connectés, dont une forêt connectée et un aquarium connecté. Technologies : Raspberry, Arduino, LoPy (Pycom), Python et MicroPython, C, HTML, CSS, PHP, JS.',
            logo: '/img/cnrs.png'
          },
          {
            title: 'IKCOM, Rivesaltes',
            role: 'Développeur full stack',
            period: '2016 à 2017',
            text: 'Développement d\'une application mobile iOS et Android avec le framework Symfony (utilisation d\'une web-view). Technologies : Symfony, HTML, CSS, PHP, JS, Java, Objective-C, scripts shell et tâches planifiées.'
          },
          {
            title: 'E-WI Télécom, Saint-Jean-d\'Angély',
            role: 'Développeur mobile',
            period: '2016',
            text: 'Développement d\'une application mobile iOS en Swift, méthodologie Kanban, UX design et ergonomie.',
            logo: '/img/e-wi.jpg'
          },
          {
            title: 'U Express Les Marines, Saint-Hilaire-de-Riez',
            role: 'Mise en rayon',
            period: '2014 à 2017, pendant les saisons',
            text: 'Horaires de nuit et de week-end, gestion de stock, facing.',
            logo: '/img/u.png'
          },
          {
            title: 'IUT de La Rochelle',
            role: 'Étudiant',
            period: '2014 à 2016',
            text: 'Projets réalisés pendant deux ans de formation :',
            items: [
              'Conception et programmation d\'un logiciel en groupe (Java)',
              'Jeu en console (C++)',
              'Conception et programmation d\'un site web en groupe',
              'Microcontrôleur en groupe (C, assembleur, Java pour l\'IHM) pour l\'entreprise Tecdron'
            ],
            logo: '/img/iut_la_rochelle.png'
          }
        ]
      }
    }
  }
</script>
